export function ConvertirAFormDataContacto(data:any){    
    const formData = new FormData();
    formData.append('nombre', data.nombre);
    formData.append('edad', data.edad);
    formData.append('email', data.email);
    formData.append('escolaridad', data.escolaridad);
    formData.append('sexo', data.sexo);
    formData.append('mensaje', data.mensaj);
    return formData;
}